<template>
  <div><slot></slot></div>
</template>

<script>
  export default {
    name: "base-sidebar-wrapper"
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/base/_base-product-sidebar-wrapper.vue